export interface ProductImageSelection { mode: "keep" | "single" | "all"; files: File[]; replaceImageUrl: string; }
const IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/heic", "image/heif"];
export function appendProductImages(form: FormData, selection: ProductImageSelection, existing: string[] = []) {
  if (selection.mode === "keep") return;
  if (!selection.files.length || selection.files.length > 5) throw new Error("Select between one and five product images.");
  for (const file of selection.files) {
    if (!IMAGE_TYPES.includes(file.type)) throw new Error("Use JPEG, PNG, WebP, HEIC, or HEIF images.");
    if (file.size > 5 * 1024 * 1024) throw new Error("Each product image must be 5 MB or smaller.");
  }
  if (selection.mode === "single") {
    if (selection.files.length !== 1 || !existing.includes(selection.replaceImageUrl)) throw new Error("Choose an existing image and exactly one replacement file.");
    form.append("replaceImageUrl", selection.replaceImageUrl);
  }
  selection.files.forEach(file => form.append("image", file));
}
